/**
 * Timeout model
 */

define(function(require) {
    var BaseModel = require('common/base.model');
    var server = require('server');
    var _ = require('underscore');
    var $ = require('j');

    return BaseModel.extend({

        parse: function(resp) {
            var data = resp.data;

            return _.extend({}, data, {
                timeouts: _.map(data.timeouts, function(timeout) {
                    return _.extend({}, timeout, {
                        startTime: window.Playtech.API.formatter.parseImsDate(timeout.startTime),
                        endTime: window.Playtech.API.formatter.parseImsDate(timeout.endTime)
                    });
                })
            });
        },

        sync: function(method, model, options) {
            if (method === 'read') {
                return $.when(this.getTimeout(), this.getAvailablePeriods())
                    .done((timeoutResponse, availablePeriodsResponse) => {
                        model.set('availablePeriods', availablePeriodsResponse?.data?.timeoutConfigurationItems?.[0]?.availablePeriods);
                        options.success?.(timeoutResponse);
                    })
                    .fail(options.error);
            }

            return this.setTimeout();
        },

        getAvailablePeriods: function() {
            return server.send({
                ID: 32942,
                description: 'Get Responsible Gaming Configuration',
                type: [0],
                responses: [32943, 32944]
            });
        },

        getTimeout: function() {
            return server.send({
                ID: 89909,
                description: 'Get time out request',
                count: 3,
                responses: [89911, 89900]
            });
        },

        setTimeout: function() {
            return server.send({
                ID: 89910,
                description: 'Set time out request',
                period: this.get('timeoutPeriod'),
                emailNotificationType: ['START'],
                correlationId: 'set-player-timeout',
                responses: [89912, 89900]
            });
        }
    });

});

